import { useCallback } from "react";

import { RULE_IMPLEMENTATION_TYPE_LABELS } from "src/constants/rules";
import { useT } from "src/internationalization";
import { RuleImplementationType } from "src/types/rule";

export const useGetRuleImplementationTypeLabel = () => {
  const t = useT();

  const getRuleImplementationTypeLabel = useCallback(
    (implementationType: RuleImplementationType) => {
      return t(RULE_IMPLEMENTATION_TYPE_LABELS[implementationType]);
    },
    [t]
  );

  return getRuleImplementationTypeLabel;
};
